<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Inventário de Estoque
    </div>

    <v-card>
      <v-card-title>
        <span>Filtros</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <!-- <v-col cols="5">
            <v-autocomplete
              v-model="harvestId"
              label="Safra"
              :items="harvestList"
              item-value="id"
              item-text="name"
              @change="loadCulturesFromHarvest"
              clearable
              @click:clear="harvestId = null; cultureList = []; cultureId = null"
              :loading="harvestListLoading"
            />
          </v-col>

          <v-col cols="5">
            <v-autocomplete
              v-model="cultureId"
              label="Cultura (opcional)"
              :items="cultureList"
              item-value="id"
              item-text="name"
              :disabled="!harvestId"
              clearable
              @click:clear="cultureId = null"
              @change="loadPeriodsFromHarvestAndCulture"
              :loading="cultureListLoading"
              hint="Se nenhuma cultura for selecionada, todas serão exibidas"
              persistent-hint
            />
          </v-col> -->

          <v-col cols="12" sm="12" md="7">
            <v-autocomplete
              v-model="storageIds"
              label="Estoque(s)"
              :items="storageList"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="storageIds = []"
              :loading="storageListLoading"
              multiple
              chips
              dense
              deletable-chips
              hint="Selecione pelo menos 1 estoque"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-switch 
              v-model="showEmptyItems" 
              inset 
              label="Exibir Itens Zerados">
            </v-switch>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-btn 
              @click="loadStorageInventoryReport"
              :disabled="storageIds.length < 1"
              class="mt-2"
            >
              <v-icon left>mdi-magnify</v-icon>
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div>
      <BasePrint
        printableElementId="storageInventoryReportTable"
        printButtonLabel="Imprimir"
        printTitle="Relatório de Inventário de Estoque"
        @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false"
        v-if="storageInventory"
        class="mt-3"
      />
    </div>

    <div id="storageInventoryReportTable">
      
      <v-row>
        <v-col cols="12" v-for="storage in storageInventory" :key="storage.name+'storage'">
          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="tableHeaders"
            :table-items="storage.items"
            :indexNested="true"
            :disablePagination="true"
            :containTopToolbar="false"
            :maskFields="maskFields"
            :hasTableTitle="true"
            :tableTitle="'Inventário do Estoque: ' + storage.name"
          />
        </v-col>
      </v-row>
    </div>
    
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      tableItems: [],
      storageInventory: null,
      pageLoading: false,
      loading: false,
      showEmptyItems: false,
      storageListLoading: false,
      storageList: [],
      storageIds: [],
      tableHeaders: [
        { text: "Item", align: "left", sortable: true, value: "name" },
        { text: "Grupo", align: "left", sortable: true, value: "group" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging" },
        // { text: "Unidade", align: "left", sortable: true, value: "item.unit.name" },
        { text: "Qtd. em Estoque", align: "left", sortable: true, value: "availableQuantity" },
        // { text: "R$ Médio", align: "left", sortable: true, value: "averageUnitPrice" },
        // { text: "R$ Médio Total", align: "left", sortable: true, value: "availableTotalPrice" },
        { text: "Qtd. em Inventário", align: "left", sortable: true, value: "inventoryQuantity" },
        { text: "Localização", align: "left", sortable: true, value: "inventoryLocation" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        // { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        { field: 'availableQuantity', mask: 'number_row_unit', unit: 'unit' },
        { field: 'inventoryQuantity', mask: 'blank_field_row_unit', unit: 'unit' },
        { field: 'inventoryLocation', mask: 'blank_field' },
        { field: 'averageUnitPrice', mask: 'currency' },
        { field: 'availableTotalPrice', mask: 'currency' },
      ]
    };
  },
  props: {
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
  },
  created() {
    this.loadAllStorages();
  },
  mounted() { 
  },
  computed: {
    // tableHeaders: function () { }
  },
  methods: {
    loadStorageInventoryReport: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_STORAGE_INVENTORY_REPORT,
          variables: {
            // harvestId: this.harvestId, 
            // cultureId: this.cultureId, 
            storageIds: this.storageIds,
            showEmptyItems: this.showEmptyItems
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.storageInventory = response.data.accountContext.storageInventoryReport;
          // console.log("storageInventory", this.storageInventory);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    loadAllStorages: function() {
      this.storageListLoading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_STORAGES_QUERY,
          // variables: {
          //   harvestId: this.harvestId,
          //   cultureId: this.cultureId
          // },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.storageList = response.data.accountContext.allStorages;
          this.storageIds = [];
        })
        .catch(response => console.log(response))
        .finally(() => (this.storageListLoading = false));
    },
  }
};



const LOAD_STORAGE_INVENTORY_REPORT = gql `
query ($storageIds: [ID!]!, $showEmptyItems: Boolean!) {
  accountContext {
    storageInventoryReport(storageIds: $storageIds, showEmptyItems: $showEmptyItems)
  }
}
`;

const LOAD_ALL_STORAGES_QUERY = gql `
  {
    accountContext {
      allStorages{
        id
        name
      }
    }
  }
`;

</script>

<style scoped>
  /* ::v-deep .cash_inflow_item {
    color: blue;
  }
  ::v-deep .cash_outflow_item {
    color: red;
  }
  ::v-deep .group_type {
    background-color: #ffdc9d;
    font-weight: bold;
  }
  ::v-deep .direct_cost {
    background-color: #60bd60;
    font-weight: bold;
  }
  ::v-deep .service_provision_cost {
    background-color: #60bd60;
    font-weight: bold;
  }
  ::v-deep .indirect_cost {
    background-color: #60bd60;
    font-weight: bold;
  }

  ::v-deep .total_cost {
    background-color: red;
    color: white;
    font-weight: bold;
  }
  ::v-deep .total_cost:hover {
    color: black;
  }
  
  ::v-deep .area_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .area_cost:hover {
    color: black;
  }

  ::v-deep .unit_production_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .unit_production_cost:hover {
    color: black;
  }
  
  ::v-deep .unit_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .unit_cost:hover {
    color: black;
  }
  
  
  ::v-deep .total_revenue {
    background-color: #007eff;
    color: white;
    font-weight: bold;
  }
  ::v-deep .total_revenue:hover {
    color: black;
  }

  ::v-deep .period_result {
    background-color: yellow;
  }

  ::v-deep .area_result {
    background-color: yellow;
  }
  ::v-deep .unit_result {
    background-color: yellow;
  }
  ::v-deep .net_income {
    background-color: yellow;
  } */
</style>
